import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    // Handle scroll effect for header background
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle navigation with smooth transitions
    const handleNavigation = (path) => {
        setIsMobileMenuOpen(false);
        
        // Check if we're already on the destination page
        if (location.pathname === path) {
            return; // Don't trigger transition if already on the page
        }
        
        // The PageTransition component will handle the actual navigation
        // We just need to set the data attribute for the transition to pick up
        const event = new CustomEvent('navigation', { detail: { path } });
        window.dispatchEvent(event);
    };

    // Get current active route
    const getActiveRoute = () => {
        const path = location.pathname;
        if (path === '/' || path === '/work') return 'work';
        if (path === '/about') return 'about';
        if (path === '/connect') return 'connect';
        return 'work';
    };

    const activeRoute = getActiveRoute();

    return (
        <>
            <header className={`floating-nav ${isScrolled ? 'scrolled' : ''}`}>
                <div className="nav-content">
                    {/* Logo/Name */}
                    <div className="nav-logo" onClick={() => handleNavigation('/about')}>
                        <span>JACOB FAULKNER</span>
                    </div>
                    
                    {/* Navigation */}
                    <nav className="vertical-nav">
                        <ul>
                            <li>
                                <button 
                                    className={`nav-link ${activeRoute === 'work' ? 'active' : ''}`}
                                    onClick={() => handleNavigation('/work')}
                                >
                                    PROJECTS
                                </button>
                            </li>
                            <li>
                                <button 
                                    className={`nav-link connect-link ${activeRoute === 'connect' ? 'active' : ''}`}
                                    onClick={() => handleNavigation('/connect')}
                                >
                                    CONNECT
                                </button>
                            </li>
                        </ul>
                    </nav>
                    
                    {/* Mobile Menu Button */}
                    <button 
                        className="mobile-menu-toggle"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label="Toggle mobile menu"
                    >
                        ☰
                    </button>
                </div>
            </header>

            {/* Mobile Menu */}
            <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                <button 
                    className="close-menu"
                    onClick={() => setIsMobileMenuOpen(false)}
                    aria-label="Close mobile menu"
                >
                    ×
                </button>
                <nav className="mobile-nav">
                    <ul>
                        <li>
                            <button 
                                className={`nav-link ${activeRoute === 'work' ? 'active' : ''}`}
                                onClick={() => handleNavigation('/work')}
                            >
                                Projects
                            </button>
                        </li>
                        <li>
                            <button 
                                className={`nav-link ${activeRoute === 'about' ? 'active' : ''}`}
                                onClick={() => handleNavigation('/about')}
                            >
                                About
                            </button>
                        </li>
                        <li>
                            <button 
                                className={`nav-link ${activeRoute === 'connect' ? 'active' : ''}`}
                                onClick={() => handleNavigation('/connect')}
                            >
                                Connect
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    );
};

export default Header; 